// frontend/src/components/quizzes/DifficultySelector.tsx

import { QuizDifficulty, DIFFICULTY_LABEL } from '../../types/quiz.types';

interface DifficultySelectorProps {
  value: QuizDifficulty;
  onChange: (value: QuizDifficulty) => void;
}

export function DifficultySelector({ value, onChange }: DifficultySelectorProps) {
  return (
    <div className="card">
      <h3 className="quiz-card-title">Zorluk Seviyesi</h3>
      <div className="quiz-difficulty-list">
        {(Object.keys(DIFFICULTY_LABEL) as QuizDifficulty[]).map((level) => {
          const meta = DIFFICULTY_LABEL[level];
          return (
            <label key={level} className="quiz-difficulty-option">
              <input
                type="radio"
                name="difficulty"
                checked={value === level}
                onChange={() => onChange(level)}
              />
              <div>
                <div className="quiz-difficulty-title">
                  {meta.label} {meta.icon}
                </div>
                <div className="quiz-difficulty-desc">{meta.description}</div>
              </div>
            </label>
          );
        })}
      </div>
    </div>
  );
}
